"use client";
import { useCallback } from "react";
import { useRouter, useSearchParams } from "next/navigation";

export function useURLFilter() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const setFilter = useCallback(
    (key: string, value: string | number | null) => {
      const params = new URLSearchParams(searchParams.toString());

      if (value === null || value === "" || value === "all") {
        params.delete(key);
      } else {
        params.set(key, String(value));
      }

      const queryString = params.toString();
      router.push(`?${queryString}`, { scroll: false });
    },
    [router, searchParams]
  );

  const getFilter = useCallback(
    (key: string, defaultValue: string | null = null) => {
      return searchParams.get(key) ?? defaultValue;
    },
    [searchParams]
  );

  return { setFilter, getFilter };
}
